import { memo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIOverlay from 'UIComponents/overlay/UIOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ConflictErrorAlert(props) {
  return /*#__PURE__*/_jsx(UIOverlay, {
    centerContent: true,
    className: "p-all-0",
    contextual: true,
    use: "light",
    width: "100%",
    children: /*#__PURE__*/_jsxs(UIAlert, {
      className: "p-y-4",
      "data-test-id": "conflict-error-alert",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.errors.conflict.title"
      }),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "conflict-alert-message",
        message: "app.escalations.errors.conflict.body"
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-4",
        "data-test-id": "conflict-error-alert-resolve-button",
        onClick: props.onResolve,
        size: "small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.escalations.errors.conflict.resolve"
        })
      })]
    })
  });
}
ConflictErrorAlert.propTypes = {
  onResolve: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(ConflictErrorAlert);